import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Mi perro Koko tenía vómitos todos los días hace más de un año. Con la guía de transición de 20 días del sistema, en la segunda semana ya no vomitaba. Ahora tiene 3 meses comiendo así y está como nuevo. No puedo creer que la solución era tan simple.',
    author: 'Valentina R., Buenos Aires',
    pet: 'Dueña de Koko, Border Collie de 5 años'
  }, {
    quote: 'Gastaba casi $18.000 por mes en comida premium que mi gata ni tocaba. Con Alimenta Con Amor gasto menos de $7.000 y ella come todo con una ansiedad que da ternura. El pelaje le cambió completamente. Vale 10 veces lo que cuesta.',
    author: 'Martín G., Rosario',
    pet: 'Dueño de Luna, gata Persa de 3 años'
  }, {
    quote: 'Mi veterinaria me dijo que siguiera comprando la bolsa de $12.000. Le mostré el análisis nutricional comparado que viene en el sistema y se quedó sin palabras. Ahora yo le recomiendo el sistema a ella para sus pacientes.',
    author: 'Sofía M., Córdoba',
    pet: 'Dueña de Beto y Cuca, Labradores'
  }];
  return <section className="py-10 px-4 bg-white" data-id="element-250">
      <div className="max-w-6xl mx-auto" data-id="element-251">
        <div className="text-center mb-6" data-id="element-252">
          <h2 className="text-3xl md:text-5xl font-black text-forest-green mb-3 font-serif" data-id="element-253">
            Escuchá Lo Que Dicen Los Dueños Que Ya Lo Vivieron:
          </h2>
          <div className="w-24 h-1.5 bg-gold mx-auto rounded-full" data-id="element-254"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-255">
          {testimonials.map((t, idx) => <div key={idx} className="bg-cream p-5 md:p-6 rounded-2xl shadow-md border border-gray-100 border-t-4 border-t-gold flex flex-col h-full relative" data-id="element-256">
              <Quote className="absolute top-4 right-4 w-10 h-10 text-gold/20 rotate-180" data-id="element-257" />

              <div className="flex gap-1 mb-3 relative z-10" data-id="element-258">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold drop-shadow-sm" data-id="element-259" />)}
              </div>

              <p className="text-gray-800 italic mb-4 text-lg leading-relaxed flex-grow font-medium relative z-10" data-id="element-260">
                "{t.quote}"
              </p>

              <div className="mt-auto pt-4 border-t-2 border-gray-200/60 bg-white/50 -mx-5 -mb-5 p-5 rounded-b-xl md:-mx-6 md:-mb-6 md:p-6" data-id="element-261">
                <p className="font-black text-forest-green text-lg" data-id="element-262">
                  {t.author}
                </p>
                <p className="text-sm font-bold text-gray-500 mt-1 uppercase tracking-wide" data-id="element-263">
                  {t.pet}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}